import { ContentBodyList } from '@molecules/*';

export type BodyContentProps = {
  content: {
    sectionHeader?: string;
    sectionTitle?: string | JSX.Element;
    itemList?: string[];
    extraInfo?: string | JSX.Element;
  }[];
};

export const ContentBody: React.FC<BodyContentProps> = ({ content }) => {
  return (
    <>
      <div className="mt-8 flex flex-col gap-8">
        <h2 className="text-text-heading text-h2 font-semibold">
          Before you start
        </h2>
        <div className="text-bodyLg flex flex-col gap-4">
          {content.map((section, index) => (
            <ContentBodyList
              key={`${section.sectionTitle}_${index}`}
              header={section.sectionHeader}
              title={section.sectionTitle}
              itemList={section.itemList}
              info={section.extraInfo}
            />
          ))}
        </div>
      </div>
    </>
  );
};
